import { Flex, Skeleton } from "antd";

const RecapResponsiveSkeleton = () => {
  return (
    <Flex vertical className="mt-4 mx-4" gap={16}>
      <Flex className="mb-4" justify="space-between">
        <Skeleton.Button active shape="round" style={{ width: "250px" }} />
        <Skeleton.Avatar />
      </Flex>

      <Skeleton.Node active={true} style={{ width: "98%", height: "32vh" }} />
      <Flex gap={12} className="mt-2">
        <Skeleton.Button active shape={"round"} style={{ width: "100px" }} />
        <Skeleton.Button active shape={"round"} style={{ width: "100px" }} />
        <Skeleton.Button active shape={"round"} style={{ width: "100px" }} />
      </Flex>
      <Skeleton active paragraph={{ rows: 6 }} />
    </Flex>
  );
};

export default RecapResponsiveSkeleton;
